import axios from 'axios';

export default async (postalCode, cancelToken) => {
  if (!postalCode.match(/^\d\d\d\d$/)) {
    throw new Error('Invalid format.');
  }

  const response = await axios.get('/api/poststed/' + postalCode, { cancelToken });
  return response.data;
};
